module.exports = __webpack_public_path__ + "img/gm.50fe2799.svg";